<template>
    <div class="main-page">
    <div class="screen-overlay"></div>
    <LeftSudebar></LeftSudebar>
    <main class="main-wrap">
        <Navbar></Navbar>
        <section class="content-main">
            <router-view></router-view>
        </section>
        <Footer></Footer>
    </main>
  </div>
</template>
<script>
import LeftSudebar from "../components/LeftSidebar.vue";
import Navbar from "../components/Navbar.vue";
import Footer from "../components/Footer.vue";

export default {
    data() {
        return {
            
        }
    },
    components: {
        LeftSudebar,
        Navbar,
        Footer
    }
}
</script>